import { Component, OnInit } from '@angular/core'

import { OAuthService } from 'angular-oauth2-oidc'
import { filter } from 'rxjs/operators'
import { WebSocketSubject } from 'rxjs/webSocket'

import { Character, Room } from '@mmocld/data'
import { Message } from '@mmocld/message'

import { WsService } from '../api/ws.service'
import { CharacterService } from '../model/character.service'
import { UserService } from '../model/user.service'
import { Token } from './game.entity'

@Component({
  selector: 'app-game',
  templateUrl: './game.component.html',
  styleUrls: ['./game.component.scss'],
})
export class GameComponent implements OnInit {
  isLoggedIn = this.oAuthService.hasValidAccessToken()
  claims!: Token

  createName = ''
  characters: Character[] = []

  ws!: WebSocketSubject<Message>
  connectedCharacter?: Character
  joinedRoom?: Room

  constructor(
    private oAuthService: OAuthService,
    private characterService: CharacterService,
    private userService: UserService,
    private wsService: WsService,
  ) {}

  ngOnInit(): void {
    this.oAuthService.events.pipe(filter((e) => e.type === 'token_received')).subscribe(() => {
      this.isLoggedIn = this.oAuthService.hasValidAccessToken()
      this.claims = <Token>this.oAuthService.getIdentityClaims()
    })
    this.claims = <Token>this.oAuthService.getIdentityClaims()

    this.userService.findAllCharacters('self').subscribe((characters) => {
      this.characters.push(...characters)
    })
  }
  ngOnDestroy() {
    if (this.ws) this.ws.complete()
  }

  connect(character: Character) {
    this.ws = this.wsService.connect(character)
    this.connectedCharacter = character
    this.ws.subscribe({
      next: (message) => {
        this.recieveMessage(message)
      },
      error: () => {
        this.disconnect()
      },
      complete: () => {
        this.disconnect()
      },
    })
  }
  disconnect() {
    this.ws.complete()
    this.connectedCharacter = undefined
    this.joinedRoom = undefined
  }
  recieveMessage(message: Message) {
    if (!message.type?.includes('Chat')) return
  }

  createCharacter() {
    this.characterService.create({ name: this.createName }).subscribe((character) => {
      this.characters.push(character)
    })
    this.createName = ''
  }
  deleteCharacter(character: Character) {
    this.characterService.delete(character.characterId).subscribe()
    this.characters = this.characters.filter((c) => c !== character)
  }

  setRoom(room: Room | undefined) {
    this.joinedRoom = room
  }
}
